import store from '../redux/store';
import { batchActions } from 'redux-batched-actions';
import LZString from 'lz-string'

import {
    selectCharacter,
    selectUser,
    selectCurrentTiles,
    selectMaterialTypes,
    selectTileTypes,
    selectPlantTypes,
    selectMineralTypes,
    selectToolTypes,
    selectMetalTypes,
    selectKeyTypes,
    selectMachineTypes,
    selectFurnitureTypes,
    selectConstructionTypes,
    selectWritingSurfaceTypes,
    selectWritingImplementTypes,
    selectBoatTypes,
    selectTentTypes,
    selectWagonTypes,
    selectWorkshopTypes,
    selectWeaponTypes,
    selectArmourTypes,
    selectClothingTypes,
    selectJewelleryTypes,
    selectFoodTypes,
    selectLockTypes,
    selectAnimalTypes,
    selectPlantProducts,
    selectConstructionRecipes,
    selectBrainchipTypes,
    selectCharacters,
    selectBoats,
    selectAnimals,
    selectBrainchips,
    selectActiveBrainchips,
    selectConstructions
} from '../redux/selectors';
import { showCharacterDeathPage } from '../redux/actions/user.actions';
import { getDeadCharactersAsync } from '../redux/actions/dead-characters.actions';
import { getCharacterSuccess, addCharacter, updateCharacter, removeCharacter, getCharacterAsync } from '../redux/actions/character.actions';
import { addConstruction, updateConstruction, removeConstruction } from '../redux/actions/construction.actions';
import { addPlant, updatePlant, removePlant } from '../redux/actions/plant.actions';
import { getTileMineralsAsync, removeMineral, addMineral, updateMineral } from '../redux/actions/mineral.actions';
import { addMachine, updateMachine, removeMachine } from '../redux/actions/machine.actions';
import { groupEmbarkSuccess } from '../redux/actions/embark-character.actions';
import { addLock, updateLock, removeLock } from '../redux/actions/lock.actions';
import { addFurniture, updateFurniture, removeFurniture } from '../redux/actions/furniture.actions';
import { addWeapon, updateWeapon, removeWeapon } from '../redux/actions/weapon.actions';
import { addArmour, updateArmour, removeArmour } from '../redux/actions/armour.actions';
import { addClothing, updateClothing, removeClothing } from '../redux/actions/clothing.actions';
import { addJewellery, updateJewellery, removeJewellery } from '../redux/actions/jewellery.actions';
import { addTool, updateTool, removeTool } from '../redux/actions/tool.actions';
import { addMetal, updateMetal, removeMetal } from '../redux/actions/metal.actions';
import { addKey, updateKey, removeKey } from '../redux/actions/key.actions';
import { removeTile, addTile, updateTile } from '../redux/actions/tile.actions';
import { addFood, updateFood, removeFood } from '../redux/actions/food.actions';
import { addWritingSurface, updateWritingSurface, removeWritingSurface } from '../redux/actions/writing-surface.actions';
import { addWritingImplement, updateWritingImplement, removeWritingImplement } from '../redux/actions/writing-implement.actions';
import { removeMaterial, addMaterial, updateMaterial } from '../redux/actions/inventory.actions';
import { addAnimal, updateAnimal, removeAnimal } from '../redux/actions/animal.actions';
import { addFish, updateFish, removeFish } from '../redux/actions/fish.actions';
import { addBoat, updateBoat, removeBoat } from '../redux/actions/boat.actions';
import { addTent, updateTent, removeTent } from '../redux/actions/tent.actions';
import { addWagon, updateWagon, removeWagon } from '../redux/actions/wagon.actions';
import { addWorkshop, updateWorkshop, removeWorkshop } from '../redux/actions/workshop.actions';
import { addBrainchip, updateBrainchip, removeBrainchip } from '../redux/actions/brainchip.actions';
import { addCriminal, updateCriminal, removeCriminal } from '../redux/actions/criminal.actions';
import { initialisingPanelStarted, showNearDeathScreen, showLevelUpMessage, showHungerWarning, showUnknownError } from '../redux/actions/keyboard-shortcuts.actions';
import { createCurrencySuccess } from '../redux/actions/currency.actions';
import { createCoinSuccess, removeCoinSuccess, updateCoinSuccess} from '../redux/actions/coin.actions';
import { getCoinTypesSuccess } from '../redux/actions/coin-types.actions';
import { getCoinRecipesSuccess } from '../redux/actions/coin-recipes.actions';
import { addPrompt, updatePrompt, removePrompt } from '../redux/actions/prompt.actions'
import { addDiaryEntry, updateDiaryEntry, removeDiaryEntry } from '../redux/actions/diary-entries.actions'
import { addCharacterPanelSuccess, removeCharacterPanelSuccess } from '../redux/actions/character-panel.actions';

import { getMoreMessagesSuccess } from '../redux/actions/messages.actions';
import { addOrganisation, updateOrganisationsSuccess, removeOrganisationSuccess } from '../redux/actions/organisation.actions';
import { createZoneSuccess, updateZoneSuccess, removeZoneSuccess } from '../redux/actions/zone.actions';
import { addOrder, updateOrder, removeOrder, addCompletedOrder, updateCompletedOrder, removeCompletedOrder } from '../redux/actions/order.actions';
import { getTentBoundries } from './tent-helpers';

import tileMap from './tile-map';
import { addRidges, addCoast, addRivers, addLake, PANEL_WIDTH, PANEL_HEIGHT } from './geography';
import { BALANCE } from './balance-config';

import seedrandom from 'seedrandom';

import { client } from './client';
import { colyClient } from './Panel-initialisation.service';

import { assignNeighbouringWalls } from '../redux/reducers/constructions';

class WebhooksService {
    character;
    user;
    tiles;
    drivenBoat;

    materialTypes;
    mineralTypes;
    plantTypes;
    tileTypes;
    isPassenger;

    animals;
    characters;

    webhookInterval;

    animationService;
    characterWalkAnimations = [];
    dispatchQueue = []
    isMessagesAdded = false
    unsubFunctions = []

    storeSubscription;

    addClothingTypes(clothingItem) {
        return {
            ...clothingItem,
            type: (
                clothingItem.itemType === 'clothing' ?
                this.clothingTypeDictionary[clothingItem.itemTypeId]
                : this.jewelleryTypeDictionary[clothingItem.itemTypeId]
            )
        }
    }

    addToQueue(action) {
        if (this.dispatchQueue) {
            this.dispatchQueue.push(action);
        }
    }

    constructor(tilemapService, audioService, roomId) {
        this.tilemapService = tilemapService;
        this.audioService = audioService;
        this.roomId = roomId;

        const state = store.getState();

        this.materialTypes = selectMaterialTypes(state);
        this.mineralTypes = selectMineralTypes(state);
        this.plantTypes = selectPlantTypes(state);
        this.tileTypes = selectTileTypes(state);
        this.toolTypes = selectToolTypes(state);
        this.metalTypes = selectMetalTypes(state);
        this.keyTypes = selectKeyTypes(state);
        this.machineTypes = selectMachineTypes(state);
        this.furnitureTypes = selectFurnitureTypes(state);
        this.constructionTypes = selectConstructionTypes(state);
        this.writingSurfaceTypes = selectWritingSurfaceTypes(state);
        this.writingImplementTypes = selectWritingImplementTypes(state);
        this.weaponTypes = selectWeaponTypes(state);
        this.armourTypes = selectArmourTypes(state);
        this.clothingTypes = selectClothingTypes(state);
        this.jewelleryTypes = selectJewelleryTypes(state);
        this.foodTypes = selectFoodTypes(state);
        this.lockTypes = selectLockTypes(state);
        this.animalTypes = selectAnimalTypes(state);
        this.boatTypes = selectBoatTypes(state);
        this.brainchipTypes = selectBrainchipTypes(state);
        this.tentTypes = selectTentTypes(state);
        this.workshopTypes = selectWorkshopTypes(state);
        this.wagonTypes = selectWagonTypes(state);
        this.plantProducts = selectPlantProducts(state);
        this.constructionRecipes = selectConstructionRecipes(state);

        this.armourTypeDictionary = {};
        this.armourTypes.forEach(armourType => {
            this.armourTypeDictionary[armourType._id] = armourType;
        })

        this.weaponTypeDictionary = {};
        this.weaponTypes.forEach(weaponType => {
            this.weaponTypeDictionary[weaponType._id] = weaponType;
        })

        this.clothingTypeDictionary = {}
        this.clothingTypes.forEach(clothingType => {
            this.clothingTypeDictionary[clothingType._id] = clothingType;
        })

        this.jewelleryTypeDictionary = {}
        this.jewelleryTypes.forEach(jewelleryType => {
            this.jewelleryTypeDictionary[jewelleryType._id] = jewelleryType;
        })


        this.storeSubscription = store.subscribe(() => {
            const state = store.getState();

            this.character = selectCharacter(state);
            this.user = selectUser(state);

            // const boats = selectBoats(state);
            // this.drivenBoat = boats.find(boat => (boat.driverId === this.character._id))
            // this.isPassenger = boats.find(boat => (boat.passengerIds?.find(id => (id === this.character._id))))

            // this.characters = selectCharacters(state);
        })
    }

    clearDispatchInterval() {
        // TODO - remove all the onChange things...
        // Unsubscribes from the store (this.storeSubscription() or whatever store.subscribe returns for unsubscription)
        if (this.storeSubscription) {
            this.storeSubscription(); // if this returns the unsubscribe function
            this.storeSubscription = null;
        }

        this.tilemapService = null;
        this.audioService = null;
        this.character = null;
        this.user = null;
        this.dispatchQueue = null;

        this.unsubFunctions.forEach(unsub => {
            if (unsub) {
                unsub()
            }
        });
        this.unsubFunctions = []

        if (this.webhookInterval) {
            clearInterval(this.webhookInterval);
        }
    }

    startDispatchInterval() {
        this.webhookInterval = setInterval(() => {
            if (this.dispatchQueue.length === 0) {
                return;
            }

            store.dispatch(batchActions(this.dispatchQueue))

            this.dispatchQueue = [];
            this.isMessagesAdded = false;
        }, 400)
    }

    watchStateChanges(state) {
        this.startDispatchInterval();

        this.unsubFunctions.push(state.characters.onAdd((character) => {
            character.clothingItems = character.clothingItems?.map(clothingItem => this.addClothingTypes(clothingItem))
            character.armourType = this.armourTypeDictionary[character.armourTypeId]
            character.weaponType = this.weaponTypeDictionary[character.weaponTypeId]
            this.addToQueue(addCharacter(character))
            this.tilemapService.addCharacter(character);
        }, false));

        this.unsubFunctions.push(state.characters.onChange((_character) => {
            let character = { ..._character }
            let isChangingPanels = false;
            if (!character) {
                return;
            }

            if (character.panelId !== this.character?.panelId) {
                isChangingPanels = true;
            }

            character.clothingItems = character.clothingItems?.map(clothingItem => this.addClothingTypes(clothingItem))
            character.armourType = this.armourTypeDictionary[character.armourTypeId]
            character.weaponType = this.weaponTypeDictionary[character.weaponTypeId]
            
            this.addToQueue(updateCharacter(character))

            character = { ...state.characters.find(oldCharacter => (oldCharacter._id === character._id)), ...character }

            if (character._id === this.character?._id && !this.isPassenger) {
                if (character.level && character.level !== this.character.level) {
                    this.addToQueue(showLevelUpMessage())
                }

                if (character.healthPoints <= 0 && this.character.healthPoints > 0) {
                    this.addToQueue(showNearDeathScreen())
                }

                // if (character.hunger === BALANCE.HUNGER_IMPACTS_VALUE && this.character.hunger > 0) {
                //     this.addToQueue(showUnknownError({ message: 'Warning: You are hungry. Your HP will reduce by 1 each turn unless you eat again' }));
                // }

                if (character.position?.x === this.character.position?.x && character.position?.y === this.character.position?.y) {
                    this.addToQueue(updateCharacter(character))
                } else {
                    this.audioService.playSound('step')
                }

                if (this.character.isBeingDragged) {
                    this.addToQueue(updateCharacter({ ...character, serverPosition: character.position }))
                }
            } else {
                const previousCharacter = state.characters.find(previousCharacter => (previousCharacter._id === character._id))

                if (previousCharacter) {
                    const yDiff = Math.abs(previousCharacter.position.y - character.position.y);
                    const xDiff = Math.abs(previousCharacter.position.x - character.position.x);

                    if (yDiff > 1 || xDiff > 1) {
                        // this.animateWalking(character, previousCharacter);
                    } else {
                        this.addToQueue(updateCharacter(character))
                    }
                } else {
                    this.addToQueue(updateCharacter(character))
                }
            }

            if (isChangingPanels) {
                return;
            }

            this.tilemapService.removeCharacter(character);
            this.tilemapService.addCharacter(character);
        }));
        this.unsubFunctions.push(state.characters.onRemove((character) => {
            if (character._id === this.character._id) {
                // Bug fix - if you are right at the edge of the screen, press m twice, and move to a named location,
                // it won't detect you changed panels and just keep showing your old panel.
                // This is a terrible hack. We have to wait half a second to make sure the backend is updated.
                // I can't figure out how to just update as usual
                // store.dispatch(initialisingPanelStarted());

            } else {
                this.addToQueue(removeCharacter(character))
            }
            this.tilemapService.removeCharacter(character);
        }));
        // characters.on('leaving', (character) => {
        //     // TODO = walking animation needs fixing
        //     this.tidyUpWalkingAnimation(character);

        //     const previousCharacter = this.characters.find(previousCharacter => (previousCharacter._id === character._id))

        //     if (previousCharacter) {
        //         const yDiff = Math.abs(previousCharacter.position.y - character.position.y);
        //         const xDiff = Math.abs(previousCharacter.position.x - character.position.x);

        //         if (yDiff > 1 || xDiff > 1) {
        //             this.animateWalking(character, previousCharacter, () => (this.addToQueue(removeCharacter(character))));
        //         } else {
        //             this.addToQueue(removeCharacter(character))
        //         }
        //     }
        // });

        this.unsubFunctions.push(state.plants.onAdd((response) => {
            if (!response) {
                return;
            }
            response.plant = { ...this.plantTypes.find(plantType => plantType._id === response.plantTypeId )};
            response.plantProducts = [ ...this.plantProducts.filter(plantProduct => plantProduct.plantTypeId === response.plantTypeId )];
            this.addToQueue(addPlant(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.plants.onChange((response) => {
            if (!response) {
                return;
            }
            response.plant = { ...this.plantTypes.find(plantType => plantType._id === response.plantTypeId )};
            response.plantProducts = [ ...this.plantProducts.filter(plantProduct => plantProduct.plantTypeId === response.plantTypeId )];
            this.addToQueue(updatePlant(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.plants.onRemove((response) => {
            this.addToQueue(removePlant(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.tools.onAdd((response) => {
            response.toolType = { ...this.toolTypes.find(toolType => toolType._id === response.toolTypeId )};
            this.addToQueue(addTool(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.tools.onChange((response) => {
            if (!response) {
                return;
            }
            response.toolType = { ...this.toolTypes.find(toolType => toolType._id === response.toolTypeId )};
            this.addToQueue(updateTool(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }, true));
        this.unsubFunctions.push(state.tools.onRemove((response) => {
            this.addToQueue(removeTool(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.metals.onAdd((response) => {
            response.metalType = { ...this.metalTypes.find(metalType => metalType._id === response.metalTypeId )};
            this.addToQueue(addMetal(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.metals.onChange((response) => {
            if (!response) {
                return;
            }
            this.addToQueue(updateMetal(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.metals.onRemove((response) => {
            this.addToQueue(removeMetal(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.keys.onAdd((response) => {
            response.keyType = { ...this.keyTypes.find(keyType => keyType._id === response.keyTypeId )};
            this.addToQueue(addKey(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.keys.onChange((response) => {
            if (!response) {
                return;
            }
            this.addToQueue(updateKey(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.keys.onRemove((response) => {
            this.addToQueue(removeKey(response))
            this.tilemapService.removeItem(response);
        }));
        
        this.unsubFunctions.push(state.furniture.onAdd((response) => {
            response.furnitureType = { ...this.furnitureTypes.find(furnitureType => furnitureType._id === response.furnitureTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(addFurniture(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.furniture.onChange((response) => {
            if (!response) {
                return;
            }
            response.furnitureType = { ...this.furnitureTypes.find(furnitureType => furnitureType._id === response.furnitureTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(updateFurniture(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.furniture.onRemove((response) => {
            this.addToQueue(removeFurniture(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.constructions.onAdd((response) => {
            response.construction = { ...this.constructionTypes.find(constructionType => constructionType._id === response.constructionTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            response.recipes = [ ...this.constructionRecipes?.filter(constructionRecipe => constructionRecipe.constructionTypeId === response.constructionTypeId ) ]

            const allWalls = assignNeighbouringWalls(response, selectConstructions(store.getState()), response.construction.name);
            response.neighbours = allWalls.byId[response._id].neighbours

            const isLeftNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x - 1 === response.position.x && construction.position.y === response.position.y));
            const isRightNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x + 1 === response.position.x && construction.position.y === response.position.y));
            const isTopNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x === response.position.x && construction.position.y - 1 === response.position.y));
            const isBottomNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x === response.position.x && construction.position.y + 1 === response.position.y));

            setTimeout(() => {
                if (isLeftNeighbour) {
                    const newWalls = assignNeighbouringWalls(isLeftNeighbour, selectConstructions(store.getState()), isLeftNeighbour.construction.name);
                    isLeftNeighbour.neighbours = newWalls.byId[isLeftNeighbour._id]?.neighbours
                    this.tilemapService.removeItem(isLeftNeighbour);
                    this.tilemapService.addItem(isLeftNeighbour);
                }

                if (isRightNeighbour) {
                    const newWalls = assignNeighbouringWalls(isRightNeighbour, selectConstructions(store.getState()), isRightNeighbour.construction.name);
                    isRightNeighbour.neighbours = newWalls.byId[isRightNeighbour._id]?.neighbours
                    this.tilemapService.removeItem(isRightNeighbour);
                    this.tilemapService.addItem(isRightNeighbour);
                }

                if (isTopNeighbour) {
                    const newWalls = assignNeighbouringWalls(isTopNeighbour, selectConstructions(store.getState()), isTopNeighbour.construction.name);
                    isTopNeighbour.neighbours = newWalls.byId[isTopNeighbour._id]?.neighbours
                    this.tilemapService.removeItem(isTopNeighbour);
                    this.tilemapService.addItem(isTopNeighbour);
                }

                if (isBottomNeighbour) {
                    const newWalls = assignNeighbouringWalls(isBottomNeighbour, selectConstructions(store.getState()), isBottomNeighbour.construction.name);
                    isBottomNeighbour.neighbours = newWalls.byId[isBottomNeighbour._id]?.neighbours
                    this.tilemapService.removeItem(isBottomNeighbour);
                    this.tilemapService.addItem(isBottomNeighbour);
                }
            }, 500)

            this.addToQueue(addConstruction(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.constructions.onChange((response) => {
            if (!response) {
                return;
            }

            response.construction = { ...this.constructionTypes.find(constructionType => constructionType._id === response.constructionTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            response.recipes = [ ...this.constructionRecipes?.filter(constructionRecipe => constructionRecipe.constructionTypeId === response.constructionTypeId ) ]
            this.addToQueue(updateConstruction(response))
            const allWalls = assignNeighbouringWalls(response, selectConstructions(store.getState()), response.construction.name);
            response.neighbours = allWalls.byId[response._id].neighbours

            const isLeftNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x - 1 === response.position.x && construction.position.y === response.position.y));
            const isRightNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x + 1 === response.position.x && construction.position.y === response.position.y));
            const isTopNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x === response.position.x && construction.position.y - 1 === response.position.y));
            const isBottomNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x === response.position.x && construction.position.y + 1 === response.position.y));

            if (isLeftNeighbour) {
                this.tilemapService.removeItem(isLeftNeighbour);
                this.tilemapService.addItem(isLeftNeighbour);
            }

            if (isRightNeighbour) {
                this.tilemapService.removeItem(isRightNeighbour);
                this.tilemapService.addItem(isRightNeighbour);
            }

            if (isTopNeighbour) {
                this.tilemapService.removeItem(isTopNeighbour);
                this.tilemapService.addItem(isTopNeighbour);
            }

            if (isBottomNeighbour) {
                this.tilemapService.removeItem(isBottomNeighbour);
                this.tilemapService.addItem(isBottomNeighbour);
            }

            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.constructions.onRemove((response) => {
            if (!response) {
                return;
            }

            response.construction = { ...this.constructionTypes.find(constructionType => constructionType._id === response.constructionTypeId )};
            response.recipes = [ ...this.constructionRecipes?.filter(constructionRecipe => constructionRecipe.constructionTypeId === response.constructionTypeId ) ]

            const allWalls = assignNeighbouringWalls(response, selectConstructions(store.getState()), response.construction.name);
            response.neighbours = allWalls.byId[response._id].neighbours

            const isLeftNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x - 1 === response.position.x && construction.position.y === response.position.y));
            const isRightNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x + 1 === response.position.x && construction.position.y === response.position.y));
            const isTopNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x === response.position.x && construction.position.y - 1 === response.position.y));
            const isBottomNeighbour = Object.values(allWalls.byId).find(construction => (construction.position.x === response.position.x && construction.position.y + 1 === response.position.y));

            if (isLeftNeighbour) {
                this.tilemapService.removeItem(isLeftNeighbour);
                this.tilemapService.addItem(isLeftNeighbour);
            }

            if (isRightNeighbour) {
                this.tilemapService.removeItem(isRightNeighbour);
                this.tilemapService.addItem(isRightNeighbour);
            }

            if (isTopNeighbour) {
                this.tilemapService.removeItem(isTopNeighbour);
                this.tilemapService.addItem(isTopNeighbour);
            }

            if (isBottomNeighbour) {
                this.tilemapService.removeItem(isBottomNeighbour);
                this.tilemapService.addItem(isBottomNeighbour);
            }

            this.addToQueue(removeConstruction(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.writingSurfaces.onAdd((response) => {
            response.writingSurfaceType = { ...this.writingSurfaceTypes.find(writingSurfaceType => writingSurfaceType._id === response.writingSurfaceTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(addWritingSurface(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.writingSurfaces.onChange((response) => {
            if (!response) {
                return;
            }
            const parsedGraffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : ''
            const parsedPixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : ''
            response = {
                ...response,
                graffiti: parsedGraffiti,
                pixelsArray: parsedPixelsArray
            }
            this.addToQueue(updateWritingSurface(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.writingSurfaces.onRemove((response) => {
            this.addToQueue(removeWritingSurface(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.writingImplements.onAdd((response) => {
            response.writingImplementType = { ...this.writingImplementTypes.find(writingImplementType => writingImplementType._id === response.writingImplementTypeId )};
            this.addToQueue(addWritingImplement(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.writingImplements.onChange((response) => {
            if (!response) {
                return;
            }
            this.addToQueue(updateWritingImplement(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.writingImplements.onRemove((response) => {
            this.addToQueue(removeWritingImplement(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.weapons.onAdd((response) => {
            response.weaponType = { ...this.weaponTypes.find(weaponType => weaponType._id === response.weaponTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(addWeapon(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.weapons.onChange((response) => {
            if (!response) {
                return;
            }
            response.weaponType = { ...this.weaponTypes.find(weaponType => weaponType._id === response.weaponTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(updateWeapon(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.weapons.onRemove((response) => {
            this.addToQueue(removeWeapon(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.armour.onAdd((response) => {
            response.armourType = { ...this.armourTypes.find(armourType => armourType._id === response.armourTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(addArmour(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.armour.onChange((response) => {
            if (!response) {
                return;
            }
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(updateArmour(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.armour.onRemove((response) => {
            this.addToQueue(removeArmour(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.clothing.onAdd((response) => {
            response.clothingType = { ...this.clothingTypeDictionary[response.clothingTypeId] };
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(addClothing(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.clothing.onChange((response) => {
            if (!response) {
                return;
            }
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            this.addToQueue(updateClothing(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
            
        this.unsubFunctions.push(state.clothing.onRemove((response) => {
            this.addToQueue(removeClothing(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.food.onAdd((response) => {
            response.foodType = { ...this.foodTypes.find(foodType => foodType._id === response.foodTypeId )};
            this.addToQueue(addFood(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.food.onChange((response) => {
            if (!response) {
                return;
            }
            if (response.quantity === 0) {
                this.addToQueue(removeFood(response))
            } else {
                this.addToQueue(updateFood(response))
            }
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.food.onRemove((response) => {
            this.addToQueue(removeFood(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.materials.onAdd((response) => {
            response.materialType = this.materialTypes.find(materialType => materialType._id === response.materialTypeId);
            response.plant = this.plantTypes.find(plantType => plantType._id === response.plantTypeId);
            response.animal = this.animalTypes.find(animalType => animalType._id === response.animalTypeId);
            this.addToQueue(addMaterial(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.materials.onChange((response) => {
            if (!response) {
                return;
            }
            this.addToQueue(updateMaterial(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.materials.onRemove((response) => {
            this.addToQueue(removeMaterial(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.locks.onAdd((response) => {
            response.lockType = { ...this.lockTypes.find(lockType => lockType._id === response.lockTypeId )};
            this.addToQueue(addLock(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.locks.onChange((response) => {
            if (!response) {
                return;
            }
            response.lockType = { ...this.lockTypes.find(lockType => lockType._id === response.lockTypeId )};
            this.addToQueue(updateLock(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.locks.onRemove((response) => {
            this.addToQueue(removeLock(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.tiles.onAdd((response) => {
            response.tileType = { ...this.tileTypes.find(tileType => tileType._id === response.tileTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            store.dispatch(addTile(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.tiles.onChange((response) => {
            if (!response) {
                return;
            }
            response.tileType = { ...this.tileTypes.find(tileType => tileType._id === response.tileTypeId )};
            response.pixelsArray = (response.pixelsArray && Array.isArray(response.pixelsArray)) ? response.pixelsArray : response.pixelsArray ? JSON.parse(LZString.decompressFromUTF16(response.pixelsArray)) : '';
            response.graffiti = (response.graffiti && Array.isArray(response.graffiti)) ? response.graffiti : response.graffiti ? JSON.parse(LZString.decompressFromUTF16(response.graffiti)) : '';
            store.dispatch(updateTile(response));
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.tiles.onRemove((response) => {
            response.tileType = { ...this.tileTypes.find(tileType => tileType._id === response.tileTypeId )};
            store.dispatch(removeTile(response));
            this.tilemapService.removeItem(response);
        }))

        this.unsubFunctions.push(state.minerals.onAdd((response) => {
            response.mineralType = { ...this.mineralTypes.find(mineralType => mineralType._id === response.mineralTypeId) }
            this.addToQueue(addMineral(response))
            if (!response.characterId) {
                this.tilemapService.addItem(response);
            }
        }, false));
        this.unsubFunctions.push(state.minerals.onChange((response) => {
            if (!response) {
                return;
            }
            this.addToQueue(updateMineral(response));
            if (!response.characterId) {
                this.tilemapService.removeItem(response);
                this.tilemapService.addItem(response);
            }
        }))
        this.unsubFunctions.push(state.minerals.onRemove((response) => {
            this.addToQueue(removeMineral(response))
            // TODO - turn this back on :)
            if (!response.characterId) {
                this.tilemapService.removeItem(response);
            }
        }));

        this.unsubFunctions.push(state.animals.onAdd((response) => {
            response.animal = { ...this.animalTypes.find(animalType => animalType._id === response.animalTypeId) }
            this.addToQueue(addAnimal(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.animals.onChange((response) => {
            if (!response) {
                return;
            }
            const originalAnimals = selectAnimals(store.getState())
            const originalAnimal = originalAnimals.find(animal => (animal.id === response.id))
            response = { ...originalAnimal, ...response };
            response.animal = { ...this.animalTypes.find(animalType => animalType._id === response.animalTypeId) }
            this.addToQueue(updateAnimal(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.animals.onRemove((response) => {
            this.addToQueue(removeAnimal(response))
            this.tilemapService.removeItem(response);
        }));


        this.unsubFunctions.push(state.workshops.onAdd((response) => {
            response.workshopType = { ...this.workshopTypes.find(workshopType => workshopType._id === response.workshopTypeId )};
            response.workshopBoundries = getTentBoundries(response.position, 'north', response.workshopType)
            this.addToQueue(addWorkshop(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.workshops.onChange((response) => {
            if (!response) {
                return;
            }
            response.workshopType = { ...this.workshopTypes.find(workshopType => workshopType._id === response.workshopTypeId )};
            response.workshopBoundries = getTentBoundries(response.position, 'north', response.workshopType)
            this.addToQueue(updateWorkshop(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.workshops.onRemove((response) => {
            response.workshopType = { ...this.workshopTypes.find(workshopType => workshopType._id === response.workshopTypeId )};
            response.workshopBoundries = getTentBoundries(response.position, 'north', response.workshopType)
            this.addToQueue(removeWorkshop(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.brainchips.onAdd((response) => {
            response.brainchipType = { ...this.brainchipTypes.find(brainchipType => brainchipType._id === response.brainchipTypeId )};
            this.addToQueue(addBrainchip(response))
            this.tilemapService.addItem(response);
        }, false));
        this.unsubFunctions.push(state.brainchips.onChange((response) => {
            if (!response) {
                return;
            }
            response.brainchipType = { ...this.brainchipTypes.find(brainchipType => brainchipType._id === response.brainchipTypeId )};
            this.addToQueue(updateBrainchip(response))
            this.tilemapService.removeItem(response);
            this.tilemapService.addItem(response);
        }));
        this.unsubFunctions.push(state.brainchips.onRemove((response) => {
            this.addToQueue(removeBrainchip(response))
            this.tilemapService.removeItem(response);
        }));

        this.unsubFunctions.push(state.crimes.onAdd((response) => {
            this.addToQueue(addCriminal(response))
        }, false));
        this.unsubFunctions.push(state.crimes.onChange((response) => {
            if (!response) {
                return;
            }
            this.addToQueue(updateCriminal(response))
        }));
        this.unsubFunctions.push(state.crimes.onRemove((response) => {
            this.addToQueue(removeCriminal(response))
        }));

        this.unsubFunctions.push(state.messages.onAdd((message) => {
            if (this.isMessagesAdded === true) {
                return;
            }

            this.isMessagesAdded = true;

            if (message.panelId !== this.character?.panelId || (message.z !== undefined && message.z !== this.character?.z)) {
                return;
            }

            this.audioService.playSound('speak')
            // TODO - fire breath and other thing... shooting at position not character....
            if (message.text.indexOf('breathed fire') > -1 || message.text.indexOf('shot at') > -1 || message.text.indexOf('shot webs at') > -1 || message.text.indexOf('shot fire at') > -1) {
                // do a shoot animation
                setTimeout(() => {
                    this.tilemapService.foregroundTilemapService?.animateShooting(message)
                }, 200)
                return;
            }

            // Note we try to batch add all the messages in one event for efficiency
            this.addToQueue(getMoreMessagesSuccess({ total: state.messages.length, data: [...state.messages] }))
        }, false));
        this.unsubFunctions.push(state.messages.onChange((message) => {
            if (!message) {
                return;
            }
            this.addToQueue(getMoreMessagesSuccess(message));
        }))
        // state.messages.onRemove((message) => this.addToQueue(getMoreMessagesSuccess(message)));

        this.unsubFunctions.push(state.organisations.onAdd((organisation) => {
            this.addToQueue(addOrganisation(organisation))
        }, false))

        this.unsubFunctions.push(state.organisations.onChange((organisation) => {
            if (!organisation) {
                return;
            }

            this.addToQueue(updateOrganisationsSuccess(organisation))
        }, false))

        this.unsubFunctions.push(state.organisations.onRemove((organisation) => this.addToQueue(removeOrganisationSuccess(organisation))))

        this.unsubFunctions.push(state.zones.onAdd((zone) => {
            this.addToQueue(createZoneSuccess(zone))
        }, false))

        this.unsubFunctions.push(state.zones.onChange((zone) => {
            if (!zone) {
                return;
            }
            this.addToQueue(updateZoneSuccess(zone))
        }, false))

        this.unsubFunctions.push(state.zones.onRemove((zone) => this.addToQueue(removeZoneSuccess(zone))));

        function handleOrderUpdate(order, _this) {
            if (!order) {
                return;
            }

            if (order.characterId === _this.character?._id) {
                if (order.type === 'create') {
                    if (order.step === 7) {
                        const workshopType = _this.workshopTypes.find(type => type._id === order.workshop.workshopTypeId)

                        if (workshopType) {
                            switch (workshopType.name) {
                                case `Woodcollier's`:
                                    _this.audioService.playSound('collier')
                                    break;

                                case `Stonemason's`:
                                case `Builder's Yard`:
                                    _this.audioService.playSound('mason')
                                    break;

                                case `Carpenter's`:
                                case `Shipwright`:
                                    _this.audioService.playSound('carpenter')
                                    break;

                                case `Blacksmith's`:
                                case `Mint`:
                                case `Jewellers`:
                                    _this.audioService.playSound('blacksmith')
                                    break;

                                case `Doctors's`:
                                case `Apothecary`:
                                    _this.audioService.playSound('doctor')
                                    break;

                                case `Potter's`:
                                    _this.audioService.playSound('potter')
                                    break;

                                case `Tailor's`:
                                case `Dyer's`:
                                    _this.audioService.playSound('tailor')
                                    break;

                                case `Tannery`:
                                    _this.audioService.playSound('tanner')
                                    break;

                                case `Kitchen`:
                                    _this.audioService.playSound('kitchen')
                                    break;

                                default: 
                                    _this.audioService.playSound('craft')
                                    break;
                            }
                        }

                    } else {
                        _this.audioService.playSound('step')
                    }
                }

                if (order.type === 'build') {
                    if (order.step === 10) {
                        _this.audioService.playSound('build')
                    } else {
                        _this.audioService.playSound('step')
                    }
                }

                if (order.type === 'gather') {
                    if (order.step === 6) {
                        switch (order.data.resources) {
                            case 'wood':
                                _this.audioService.playSound('collectWood');
                                break;
                            case 'brush':
                            case 'fruit & vegetables':
                            case 'farm plot':
                            case 'tend plants':
                                _this.audioService.playSound('collectPlant');
                                break;
                            case 'minerals':
                                _this.audioService.playSound('collectMineral');
                                break;
                            case 'fuel light':
                                _this.audioService.playSound('fire');
                                break;
                            case 'repair constructions':
                                _this.audioService.playSound('masonry');
                                break;
                            case 'damage constructions':
                            default:
                                _this.audioService.playSound('fight');
                                break;
                        }
                    } else {
                        _this.audioService.playSound('step')
                    }
                }

                if (order.type === 'plant') {
                    if (order.step === 7) {
                        _this.audioService.playSound('collectPlant');
                    } else {
                        _this.audioService.playSound('step')
                    }
                }

                if (order.type === 'fight') {
                    if (order.step === 2) {
                        _this.audioService.playSound('fight');
                    } else {
                        _this.audioService.playSound('step')
                    }
                }

                if (order.type === 'torch') {
                    if (order.step === 2) {
                        _this.audioService.playSound('fire');
                    } else {
                        _this.audioService.playSound('step')
                    }
                }

                if (order.type === 'fetch') {
                    if (order.step === 2) {
                        _this.audioService.playSound('collectItem');
                    } else {
                        _this.audioService.playSound('step')
                    }
                }

                if (order.type === 'haul') {
                    if (order.step === 2 || order.step === 4) {
                        _this.audioService.playSound('collectItem');
                    } else {
                        _this.audioService.playSound('step')
                    }
                }

                if (order.type === 'torch') {
                    _this.audioService.playSound('fire');
                }

                if (order.type === 'move') {
                    _this.audioService.playSound('step')
                }
            } else {
                // console.log('some other guys order', order)
            }

            _this.addToQueue(updateOrder(order))
        }

        this.unsubFunctions.push(state.orders.onAdd((order) => {
            this.addToQueue(addOrder(order))

            order.onChange((updatedOrder) => {
                if (order.type === 'idle') {
                    handleOrderUpdate(order, this)
                }
            })
        }, false))

        state.orders.forEach((order) => {
            this.unsubFunctions.push(order.onChange((updatedOrder, thingtwo, thingthree) => {
                if (order.type === 'idle') {
                    handleOrderUpdate(order, this)
                }
            }))
        })

        this.unsubFunctions.push(state.orders.onChange((order) => {
            // console.log('updtaed order??', order);
            handleOrderUpdate(order, this)
        }, false))

        this.unsubFunctions.push(state.orders.onRemove((order) => {
            this.addToQueue(removeOrder(order))
        }))

        this.unsubFunctions.push(state.completedOrders.onAdd((order) => {
            this.addToQueue(addCompletedOrder(order))
        }, false))

        this.unsubFunctions.push(state.completedOrders.onChange((order) => {
            // console.log('completed order changed', order)
            if (!order) {
                return;
            }

            this.addToQueue(updateCompletedOrder(order))
        }, false))

        this.unsubFunctions.push(state.completedOrders.onRemove((order) => {
            this.addToQueue(removeCompletedOrder(order))
        }))

        this.unsubFunctions.push(state.characterPanels.onAdd((characterPanel) => {
            if (!characterPanel) {
                return;
            }

            this.addToQueue(addCharacterPanelSuccess({
                ...characterPanel
            }))
        }, false))

        this.unsubFunctions.push(state.characterPanels.onChange((characterPanel) => {
            if (!characterPanel) {
                return;
            }

            this.addToQueue(addCharacterPanelSuccess({
                ...characterPanel
            }))
        }, false))

        this.unsubFunctions.push(state.characterPanels.onRemove((characterPanel) => {
            this.addToQueue(removeCharacterPanelSuccess({
                ...characterPanel
            }))
        }, false))
    }

    animateWalking(character, previousCharacter, onDone) {
        if (previousCharacter.panelId !== character.panelId) {
            return;
        }

        const yDiff = Math.abs(previousCharacter.position.y - character.position.y);
        const xDiff = Math.abs(previousCharacter.position.x - character.position.x);

        let tries = 0;
        let newY;
        let newX;

        newY = this.getNewPosition(newY, previousCharacter.position.y, character.position.y);
        newX = this.getNewPosition(newX, previousCharacter.position.x, character.position.x);

        this.addToQueue(updateCharacter({ ...character, position: { x: newX, y: newY } }))

        tries++;

        const walkAnimation = setInterval(() => {
            tries++;

            newY = this.getNewPosition(newY, previousCharacter.position.y, character.position.y);
            newX = this.getNewPosition(newX, previousCharacter.position.x, character.position.x);

            this.addToQueue(updateCharacter({ ...character, position: { x: newX, y: newY } }))

            if (tries === Math.max(yDiff, xDiff)) {
                clearInterval(walkAnimation);
                if (onDone) {
                    onDone()
                }
                this.characterWalkAnimations = [ ...this.characterWalkAnimations.filter(animation => (animation._id !== character._id)) ]
            }
        }, 100)

        this.characterWalkAnimations.push({ walkAnimation, _id: character._id })

        return;
    }

    getNewPosition(lastPosition, startPosition, endPosition) {
        if (startPosition === endPosition) {
            return endPosition;
        }

        if (endPosition > startPosition) {
            if (!lastPosition) {
                return startPosition + 1
            } else {
                return lastPosition === endPosition ? endPosition : lastPosition + 1
            }
        }

        if (endPosition < startPosition) {
            if (!lastPosition) {
                return startPosition - 1
            } else {
                return lastPosition === endPosition ? endPosition : lastPosition - 1
            }
        }
    }
}

export default WebhooksService;